import type { IconData } from '@stacksjs/iconify-core'

export const minus: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1 0h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default minus
